module.exports = __webpack_public_path__ + "static/media/2025_Greenland UK_forside.0cb00d2f.jpg";